export default __webpack_public_path__ + "static/media/italic.79b334b2.woff";